<template>
  <v-container fluid class="assistente-consulta-wrap pa-0">
    <v-row class="ma-0">
      <v-col cols="12">
        <div class="ia-chat-panel">
          <div class="ia-chat-header">
            <v-avatar color="rgb(71 130 180)" size="40" class="mr-3">
              <v-icon dark>mdi-robot-happy-outline</v-icon>
            </v-avatar>
            <p class="ia-chat-header-title mb-0">Assistente de consulta</p>
          </div>

          <div class="ia-chat-apresentacao">
            <div class="ia-chat-mascote flex-shrink-0">
              <img
                :src="gerandoSqlIa ? imgIaPensando : imgIaEntrada"
                :alt="
                  gerandoSqlIa
                    ? 'Assistente processando consulta'
                    : 'Assistente de consulta'
                "
                class="ia-chat-mascote-img"
              />
            </div>
            <transition name="ia-erro-fade" mode="out-in">
              <div
                v-if="erroIaInlineVisivel && mensagemErroIaInline"
                key="erro"
                class="ia-chat-fala ia-chat-fala-erro"
              >
                <p class="ia-chat-fala-texto mb-2">{{ mensagemErroIaInline }}</p>
                <p class="ia-chat-fala-texto ia-chat-fala-erro-hint mb-0">
                  Corrija sua solicitação no campo abaixo e tente novamente.
                </p>
              </div>
              <div
                v-else-if="semResultadosVisivel && mensagemSemResultadosInline"
                key="sem-resultados"
                class="ia-chat-fala ia-chat-fala-sem-resultados"
              >
                <p class="ia-chat-fala-texto mb-0">{{ mensagemSemResultadosInline }}</p>
              </div>
              <div
                v-else-if="gerandoSqlIa"
                key="processando"
                class="ia-chat-fala ia-chat-fala-processando"
              >
                <div class="ia-chat-typing mb-2">
                  <span class="ia-typing-dot"></span>
                  <span class="ia-typing-dot"></span>
                  <span class="ia-typing-dot"></span>
                </div>
                <p class="ia-chat-fala-texto mb-0">
                 🤖 Analisando sua solicitação e preparando a consulta...

                </p>
              </div>
              <div v-else key="boas-vindas" class="ia-chat-fala">
                <p
                  v-for="(item, idx) in boasVindasParagrafosCompletos"
                  :key="'bv-' + idx"
                  class="ia-chat-fala-texto"
                  :class="classesParagrafoBoasVindas(item, idx)"
                >
                  {{ item.texto }}
                </p>
                <p
                  v-if="boasVindasParagrafoAtual || digitandoBoasVindas"
                  class="ia-chat-fala-texto"
                  :class="
                    classesParagrafoBoasVindas(
                      paragrafoBoasVindasAtualMeta,
                      boasVindasParagrafosCompletos.length
                    )
                  "
                >
                  {{ boasVindasParagrafoAtual }}<span
                    v-if="digitandoBoasVindas"
                    class="ia-cursor-digitacao"
                    aria-hidden="true"
                  ></span>
                </p>
              </div>
            </transition>
          </div>

          <div class="ia-chat-input-wrap">
            <v-textarea
              ref="campoSolicitacaoIa"
              v-model="solicitacaoIa"
              placeholder="Digite sua pergunta..."
              rows="3"
              auto-grow
              hide-details
              solo
              flat
              class="ia-chat-input"
              :disabled="gerandoSqlIa"
              @input="limparErroInline"
              @focus="limparErroInline"
              @keydown.enter.exact.prevent="gerarConsulta"
              @keydown.enter.shift.exact.stop
            ></v-textarea>
            <v-btn
              class="ia-chat-send-btn"
              fab
              small
              color="rgb(71 130 180)"
              :loading="gerandoSqlIa"
              :disabled="!solicitacaoIa || !solicitacaoIa.trim() || gerandoSqlIa"
              @click="gerarConsulta"
            >
              <v-icon dark>mdi-send</v-icon>
            </v-btn>
          </div>
          <p class="ia-chat-footer-hint mb-0">
            Enter para enviar · Shift + Enter para nova linha
          </p>
        </div>
      </v-col>
    </v-row>

    <v-row class="ma-0 mt-4">
      <v-col cols="12">
        <div class="d-flex align-center justify-space-between mb-2">
          <p class="text-subtitle-2 mb-0 font-weight-medium">Histórico</p>
          <v-btn
            icon
            small
            :loading="carregandoUltimas"
            @click="carregarUltimasIa"
          >
            <v-icon>mdi-refresh</v-icon>
          </v-btn>
        </div>
        <v-progress-linear
          v-if="carregandoUltimas"
          indeterminate
          color="primary"
          class="mb-2"
        ></v-progress-linear>
        <p
          v-else-if="!ultimasIa.length"
          class="text-body-2 grey--text text--darken-1"
        >
          Nenhuma solicitação registrada ainda.
        </p>
        <v-row v-else dense>
          <v-col
            v-for="item in ultimasIa"
            :key="item.idAgendaSql || item.id"
            cols="12"
            md="6"
          >
            <v-card outlined class="pa-3 historico-ia-card">
              <div class="d-flex align-start justify-space-between">
                <div class="flex-grow-1 pr-2">
                  <p class="text-caption grey--text mb-1">
                    #{{ item.idAgendaSql || item.id }}
                    <span v-if="dataHistoricoIa(item)">
                      · {{ dataHistoricoIa(item) }}
                    </span>
                  </p>
                  <p class="text-body-2 mb-2 historico-ia-solicitacao">
                    {{ textoSolicitacaoHistorico(item) }}
                  </p>
                  <v-chip
                    x-small
                    :color="item.sucesso ? 'green darken-1' : 'red'"
                    text-color="white"
                    class="mr-1"
                  >
                    {{ item.sucesso ? "Sucesso" : "Erro" }}
                  </v-chip>
                  <v-chip
                    v-if="item.quantidadeRegistros != null"
                    x-small
                    outlined
                    class="mr-1"
                  >
                    {{ item.quantidadeRegistros }} registro(s)
                  </v-chip>
                </div>
                <span
                  v-if="item.sucesso && (item.idAgendaSql || item.id)"
                  role="button"
                  tabindex="0"
                  class="link-novo-processamento ml-2 flex-shrink-0"
                  :class="{
                    'link-novo-processamento--disabled':
                      baixandoExcelId === (item.idAgendaSql || item.id),
                  }"
                  @click="novoProcessamentoAgenda(item.idAgendaSql || item.id)"
                  @keydown.enter.prevent="
                    novoProcessamentoAgenda(item.idAgendaSql || item.id)
                  "
                >
                  <v-progress-circular
                    v-if="baixandoExcelId === (item.idAgendaSql || item.id)"
                    indeterminate
                    size="12"
                    width="2"
                    color="rgb(71, 130, 180)"
                    class="mr-1 d-inline-block"
                  />
                  Novo Processamento
                </span>
              </div>
              <p
                v-if="!item.sucesso"
                class="text-caption mt-2 mb-0 ia-historico-erro"
              >
                {{ resumoErroHistorico(item) }}
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

    <v-dialog v-model="dialogIaErro" max-width="560">
      <v-card class="ia-erro-dialog">
        <v-card-text class="pa-6 text-center">
          <div class="ia-erro-emoji mb-3">🤖</div>
          <pre class="ia-erro-amigavel mb-4">{{ mensagemErroIaDialog }}</pre>
          <p
            v-if="ultimaRespostaIa && ultimaRespostaIa.idAgendaSql"
            class="text-caption grey--text mb-0"
          >
            Registro salvo no histórico (#{{ ultimaRespostaIa.idAgendaSql }}).
          </p>
        </v-card-text>
        <v-card-actions class="justify-center pb-4">
          <v-btn color="primary" rounded @click="fecharErroIaETentarNovamente">
            <v-icon left>mdi-message-reply-text</v-icon>
            Tentar novamente
          </v-btn>
          <v-btn text @click="fecharDialogErroIa">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogIaSemRegistros" max-width="480">
      <v-card>
        <v-card-title class="headline">Consulta executada</v-card-title>
        <v-card-text>
          A consulta foi executada com sucesso, mas não retornou registros.
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogIaSemRegistros = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogIaEscolha" max-width="560" persistent>
      <v-card>
        <v-card-title
          class="headline white--text"
          style="background-color: rgb(71 130 180)"
        >
          <v-icon color="white" class="mr-2">mdi-check-circle</v-icon>
          Consulta concluída
        </v-card-title>
        <v-card-text class="pa-4 pt-4">
          <p class="text-body-1 mb-3 font-weight-medium">
            🚀 Pronto! Sua consulta foi processada com sucesso.
          </p>
          <p class="text-body-1 mb-4">
            Localizei
            <strong>{{ quantidadeRegistrosFormatada }}</strong>
            registro(s) com base nos filtros informados.
          </p>
          <p class="text-body-2 grey--text text--darken-1 mb-1">Posso:</p>
          <v-list dense class="pa-0 assistente-escolha-list">
            <v-list-item
              class="assistente-escolha-item"
              :disabled="
                baixandoExcelId ===
                (ultimaRespostaIa && ultimaRespostaIa.idAgendaSql)
              "
              @click="baixarExcelAgenda(ultimaRespostaIa.idAgendaSql)"
            >
              <v-list-item-icon class="mr-2 my-2">
                <span class="assistente-escolha-emoji" aria-hidden="true">📥</span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Baixar planilha</v-list-item-title>
              </v-list-item-content>
              <v-list-item-action v-if="baixandoExcelId === ultimaRespostaIa?.idAgendaSql">
                <v-progress-circular indeterminate size="20" width="2" />
              </v-list-item-action>
            </v-list-item>
            <v-list-item
              class="assistente-escolha-item"
              @click="visualizarUltimosRegistros"
            >
              <v-list-item-icon class="mr-2 my-2">
                <span class="assistente-escolha-emoji" aria-hidden="true">👁️</span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Visualizar últimos registros</v-list-item-title>
                <v-list-item-subtitle>Amostra dos 20 mais recentes</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
            <v-list-item class="assistente-escolha-item" disabled>
              <v-list-item-icon class="mr-2 my-2">
                <span class="assistente-escolha-emoji" aria-hidden="true">📊</span>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>Gerar resumo dos dados</v-list-item-title>
                <v-list-item-subtitle>Ainda não disponível</v-list-item-subtitle>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="pa-4 pt-0">
          <v-spacer></v-spacer>
          <v-btn text @click="dialogIaEscolha = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogUltimosRegistros" max-width="95%" scrollable>
      <v-card>
        <v-card-title
          class="headline white--text"
          style="background-color: rgb(71 130 180)"
        >
          <v-icon color="white" class="mr-2">mdi-table</v-icon>
          Últimos registros (amostra)
        </v-card-title>
        <v-card-text class="pa-4">
          <p v-if="ultimaRespostaIa" class="text-caption mb-3">
            Exibindo até 20 linhas de
            {{ ultimaRespostaIa.quantidadeRegistros }} registro(s) encontrado(s).
          </p>
          <v-data-table
            :headers="headersUltimosRegistros"
            :items="ultimosRegistrosPreview"
            :items-per-page="20"
            hide-default-footer
            class="elevation-0"
            dense
            no-data-text="Nenhum registro na amostra"
          />
        </v-card-text>
        <v-card-actions class="pa-4">
          <v-btn
            v-if="ultimaRespostaIa && ultimaRespostaIa.idAgendaSql"
            color="success"
            text
            :loading="baixandoExcelId === ultimaRespostaIa.idAgendaSql"
            @click="baixarExcelAgenda(ultimaRespostaIa.idAgendaSql)"
          >
            <v-icon left>mdi-file-excel</v-icon>
            Baixar planilha completa
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialogUltimosRegistros = false">
            Fechar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import SqlAgent from "../../../services/sqlAgent";
import imgIaEntrada from "@/assets/img_ia_gpdf.png";
import imgIaPensando from "@/assets/img_ia_pen_gpdf.png";

/** Alinhado ao mensagemAmigavel(TipoErroIA) do backend */
const MENSAGENS_ERRO_IA = {
  SOMENTE_SELECT:
    "🛡️ Por segurança, apenas consultas de visualização de dados são permitidas no momento.",
  OVERLOADED:
    "🚀 Estou processando muitas solicitações agora. Tente novamente em alguns instantes.",
  TIMEOUT:
    "⏳ Essa consulta demorou mais do que o esperado e foi encerrada automaticamente. Tente reformular sua pergunta de forma mais específica, como filtrar por um período menor ou uma empresa específica.",
  SQL_INVALIDO:
    "🤖 Não consegui interpretar corretamente essa solicitação. Tente reformular a pergunta com mais detalhes ou de outra forma.",
  COLUNA_INVALIDA:
    "🔎 Algumas informações solicitadas não puderam ser localizadas na base de dados. Tente ajustar os campos ou filtros informados.",
  TABELA_INVALIDA:
    "📂 Não consegui localizar uma das informações necessárias para concluir essa consulta.",
  SEM_RESULTADOS: "📭 Não encontrei registros para os filtros informados.",
  ERRO_CONEXAO:
    "🌐 Ocorreu uma instabilidade ao consultar as informações. Tente novamente em alguns instantes.",
  DEFAULT:
    "🤖 Não consegui processar sua solicitação no momento. Tente reformular a pergunta ou realizar uma nova tentativa.",
};

/**
 * Código numérico da API (quando não houver pista no texto).
 * O codigo "2" pode ser TIMEOUT ou SOMENTE_SELECT — o texto da mensagem tem prioridade.
 */
const TIPO_ERRO_POR_CODIGO_NUMERICO = {
  1: "SQL_INVALIDO",
  2: "SOMENTE_SELECT",
  3: "OVERLOADED",
  4: "TIMEOUT",
  5: "COLUNA_INVALIDA",
  6: "TABELA_INVALIDA",
  7: "SEM_RESULTADOS",
  8: "ERRO_CONEXAO",
};

function textoErroPayload(payload) {
  if (!payload) {
    return "";
  }
  return [
    payload.mensagem,
    payload.mensagemErro,
    payload.mensagem2,
    payload.message,
    extrairTextoErroOrquestrar(payload.erro),
  ]
    .filter(Boolean)
    .join(" ");
}

function detectarTipoErroPorTexto(texto) {
  const t = (texto || "").toLowerCase();
  if (!t) {
    return null;
  }
  if (
    t.includes("select") &&
    (t.includes("permitid") || t.includes("somente") || t.includes("apenas"))
  ) {
    return "SOMENTE_SELECT";
  }
  if (
    t.includes("overloaded") ||
    t.includes("529") ||
    t.includes("sobrecarreg") ||
    t.includes("3 tentativas") ||
    t.includes("muitas solicita")
  ) {
    return "OVERLOADED";
  }
  if (
    t.includes("timeout") ||
    t.includes("tempo limite") ||
    t.includes("excedeu o tempo") ||
    t.includes("demorou mais") ||
    t.includes("encerrada automaticamente") ||
    /\d+\s*segundos/.test(t)
  ) {
    return "TIMEOUT";
  }
  if (t.includes("coluna") && (t.includes("invalid") || t.includes("não encontr"))) {
    return "COLUNA_INVALIDA";
  }
  if (t.includes("tabela") && (t.includes("invalid") || t.includes("não encontr"))) {
    return "TABELA_INVALIDA";
  }
  if (
    t.includes("sem resultado") ||
    t.includes("nenhum registro") ||
    t.includes("não encontrei")
  ) {
    return "SEM_RESULTADOS";
  }
  if (
    t.includes("conexão") ||
    t.includes("conexao") ||
    t.includes("instabilidade") ||
    t.includes("bad gateway")
  ) {
    return "ERRO_CONEXAO";
  }
  if (
    t.includes("interpretar") ||
    t.includes("sql inválido") ||
    t.includes("sql invalido")
  ) {
    return "SQL_INVALIDO";
  }
  return null;
}

function resolverTipoErroIA(payload) {
  if (!payload) {
    return "DEFAULT";
  }

  const codigoRaw = String(payload.codigo ?? payload.tipoErro ?? "").trim();
  const codigoUpper = codigoRaw.toUpperCase();

  if (MENSAGENS_ERRO_IA[codigoUpper]) {
    return codigoUpper;
  }

  const porTexto = detectarTipoErroPorTexto(textoErroPayload(payload));
  if (porTexto) {
    return porTexto;
  }

  const tipoNumerico = TIPO_ERRO_POR_CODIGO_NUMERICO[codigoRaw];
  if (tipoNumerico) {
    return tipoNumerico;
  }

  return "DEFAULT";
}

function mensagemAmigavelErroIa(payload) {
  const tipo = resolverTipoErroIA(payload);
  return MENSAGENS_ERRO_IA[tipo] || MENSAGENS_ERRO_IA.DEFAULT;
}

function extrairTextoErroOrquestrar(erro) {
  if (erro == null || erro === "") {
    return "";
  }
  if (typeof erro === "string") {
    return erro;
  }
  if (typeof erro === "object") {
    return erro.mensagem || erro.mensagemErro || erro.message || "";
  }
  return String(erro);
}

function possuiErroOrquestrar(erro) {
  if (erro == null || erro === "") {
    return false;
  }
  if (typeof erro === "string") {
    return erro.trim() !== "";
  }
  return true;
}

/** Unifica resposta legada (agente-sql) e nova (assistant-agent/orquestrar). */
function normalizarRespostaOrquestrar(raw) {
  if (!raw || typeof raw !== "object") {
    return { sucesso: false, quantidadeRegistros: 0, mensagemErro: "Resposta inválida." };
  }

  const formatoOrquestrar =
    "respostaFinal" in raw || "totalRegistros" in raw || "erro" in raw;

  if (!formatoOrquestrar) {
    const temErroApi =
      raw.sucesso === false ||
      raw.codigo != null ||
      Boolean(textoErroPayload(raw).trim());
    return {
      ...raw,
      sucesso: raw.sucesso === true && !temErroApi,
      quantidadeRegistros: Number(raw.quantidadeRegistros) || 0,
      mensagemErro: raw.mensagemErro || raw.mensagem || "",
    };
  }

  const temErro = possuiErroOrquestrar(raw.erro);
  const quantidadeRegistros =
    Number(raw.totalRegistros ?? raw.quantidadeRegistros) || 0;

  return {
    ...raw,
    sucesso: !temErro,
    quantidadeRegistros,
    mensagemErro: temErro ? extrairTextoErroOrquestrar(raw.erro) : raw.mensagemErro || "",
  };
}

const MENSAGENS_SEM_RESULTADOS_SUCESSO = [
  "Hmm, vasculhei tudo aqui mas não encontrei nenhum resultado para essa busca. Pode ser que não haja dados para os filtros informados. Que tal tentar com um período diferente ou outros critérios?",
  "Procurei, procurei... mas não achei nada! 🔍 Parece que não há registros para essa consulta. Tente ajustar os filtros e me pergunte novamente!",
];

const PARAGRAFOS_BOAS_VINDAS = [
  {
    texto: "🤖 Olá! Sou seu assistente inteligente de consultas.",
  },
  {
    texto:
      "Pesquise informações de forma rápida e natural, como se estivesse conversando.",
  },
  {
    texto:
      "Você pode consultar contratos, clientes, pagamentos, produtos, aniversariantes, relatórios e muito mais.",
  },
  {
    texto: "💬 Exemplo:",
    destaque: true,
  },
  {
    texto:
      "“Contratos ativos dos últimos 100 dias com empresa, produto, tipo de produto e idade do titular.”",
    exemplo: true,
  },
  {
    texto: "Digite sua solicitação e eu farei a consulta para você. 🚀",
    ultimo: true,
  },
];

export default {
  name: "FiltroConsultaMassa",

  data() {
    return {
      imgIaEntrada,
      imgIaPensando,
      solicitacaoIa: "",
      gerandoSqlIa: false,
      carregandoUltimas: false,
      baixandoExcelId: null,
      ultimasIa: [],
      ultimaRespostaIa: null,
      ultimosRegistrosPreview: [],
      mensagemErroIaInline: null,
      mensagemErroIaDialog: null,
      erroIaInlineVisivel: false,
      erroIaInlineTimeoutId: null,
      semResultadosVisivel: false,
      mensagemSemResultadosInline: null,
      dialogIaErro: false,
      dialogIaSemRegistros: false,
      dialogIaEscolha: false,
      dialogUltimosRegistros: false,
      boasVindasParagrafosCompletos: [],
      boasVindasParagrafoAtual: "",
      boasVindasIndiceParagrafo: 0,
      boasVindasIndiceChar: 0,
      digitandoBoasVindas: false,
      typewriterBoasVindasTimer: null,
    };
  },

  computed: {
    paragrafoBoasVindasAtualMeta() {
      return PARAGRAFOS_BOAS_VINDAS[this.boasVindasIndiceParagrafo] || {};
    },
    quantidadeRegistrosFormatada() {
      const qtd = Number(this.ultimaRespostaIa?.quantidadeRegistros) || 0;
      return qtd.toLocaleString("pt-BR");
    },

    headersUltimosRegistros() {
      if (!this.ultimosRegistrosPreview.length) {
        return [];
      }
      return Object.keys(this.ultimosRegistrosPreview[0]).map((key) => ({
        text: key,
        value: key,
        sortable: false,
      }));
    },
  },

  mounted() {
    this.carregarUltimasIa();
    this.$nextTick(() => this.iniciarDigitacaoBoasVindas());
  },

  beforeDestroy() {
    this.limparErroInline();
    this.pararDigitacaoBoasVindas();
  },

  watch: {
    dialogIaErro(aberto) {
      if (!aberto) {
        this.limparErroInline();
      }
    },

    gerandoSqlIa(processando) {
      if (processando) {
        this.pararDigitacaoBoasVindas();
      } else {
        this.reiniciarBoasVindasSeAplicavel();
      }
    },

    erroIaInlineVisivel(visivel) {
      if (visivel) {
        this.pararDigitacaoBoasVindas();
      } else {
        this.reiniciarBoasVindasSeAplicavel();
      }
    },

    semResultadosVisivel(visivel) {
      if (visivel) {
        this.pararDigitacaoBoasVindas();
      } else {
        this.reiniciarBoasVindasSeAplicavel();
      }
    },
  },

  methods: {
    reiniciarBoasVindasSeAplicavel() {
      if (
        !this.gerandoSqlIa &&
        !this.erroIaInlineVisivel &&
        !this.semResultadosVisivel
      ) {
        this.$nextTick(() => this.iniciarDigitacaoBoasVindas());
      }
    },

    classesParagrafoBoasVindas(item, idx) {
      const total = PARAGRAFOS_BOAS_VINDAS.length;
      const isUltimo = item.ultimo || idx === total - 1;
      return {
        "mb-2": !isUltimo && !item.exemplo,
        "mb-1": item.destaque,
        "mb-0": isUltimo,
        "font-weight-medium": item.destaque,
        "ia-chat-fala-exemplo": item.exemplo,
      };
    },

    iniciarDigitacaoBoasVindas() {
      this.pararDigitacaoBoasVindas();
      this.boasVindasParagrafosCompletos = [];
      this.boasVindasParagrafoAtual = "";
      this.boasVindasIndiceParagrafo = 0;
      this.boasVindasIndiceChar = 0;
      this.digitandoBoasVindas = true;
      this.avancarDigitacaoBoasVindas();
    },

    pararDigitacaoBoasVindas() {
      if (this.typewriterBoasVindasTimer) {
        clearTimeout(this.typewriterBoasVindasTimer);
        this.typewriterBoasVindasTimer = null;
      }
      this.digitandoBoasVindas = false;
    },

    avancarDigitacaoBoasVindas() {
      if (this.boasVindasIndiceParagrafo >= PARAGRAFOS_BOAS_VINDAS.length) {
        this.digitandoBoasVindas = false;
        return;
      }

      const meta = PARAGRAFOS_BOAS_VINDAS[this.boasVindasIndiceParagrafo];
      const textoCompleto = meta.texto;

      if (this.boasVindasIndiceChar < textoCompleto.length) {
        this.boasVindasParagrafoAtual += textoCompleto[this.boasVindasIndiceChar];
        this.boasVindasIndiceChar += 1;
        const char = textoCompleto[this.boasVindasIndiceChar - 1];
        const atraso = char === " " || char === "\n" ? 28 : 18;
        this.typewriterBoasVindasTimer = setTimeout(
          () => this.avancarDigitacaoBoasVindas(),
          atraso
        );
        return;
      }

      this.boasVindasParagrafosCompletos.push({ ...meta });
      this.boasVindasParagrafoAtual = "";
      this.boasVindasIndiceChar = 0;
      this.boasVindasIndiceParagrafo += 1;
      const pausaEntreParagrafos = 320;
      this.typewriterBoasVindasTimer = setTimeout(
        () => this.avancarDigitacaoBoasVindas(),
        pausaEntreParagrafos
      );
    },
    extrairPayloadErro(err) {
      const data = err?.response?.data;
      if (!data) {
        return {
          mensagemErro: err?.message || "Erro ao executar a consulta.",
        };
      }
      if (typeof data === "string") {
        return { mensagemErro: data };
      }
      return {
        codigo: data.codigo,
        tipoErro: data.tipoErro,
        mensagem: data.mensagem,
        mensagemErro: data.mensagemErro || data.mensagem || data.message,
        mensagem2: data.mensagem2,
        erro: data.erro,
      };
    },

    obterMensagemErroIa(data) {
      if (!data) {
        return MENSAGENS_ERRO_IA.DEFAULT;
      }

      const normalizado = normalizarRespostaOrquestrar(data);
      const payload = { ...data, ...normalizado };

      if (normalizado.sucesso && !payload.codigo && !textoErroPayload(payload)) {
        return "";
      }

      const msgAmigavel = mensagemAmigavelErroIa(payload);
      const msgBackend = textoErroPayload(payload);

      if (
        msgBackend &&
        (msgBackend.includes("🛡️") ||
          msgBackend.includes("🚀") ||
          msgBackend.includes("🤖 Não consegui processar") ||
          msgBackend.includes("🤖 Não consegui interpretar"))
      ) {
        return msgBackend;
      }

      return msgAmigavel;
    },

    resumoErroHistorico(item) {
      const msg = this.obterMensagemErroIa(item);
      if (!msg) {
        return "";
      }
      const linha = msg.split("\n").find((l) => l.trim()) || msg;
      return linha.length > 120 ? `${linha.slice(0, 117)}...` : linha;
    },

    enriquecerRespostaComHistorico(data, solicitacao) {
      if (!data.sucesso || data.idAgendaSql || !this.ultimasIa.length) {
        return data;
      }
      const solicitacaoNorm = (solicitacao || "").trim().toLowerCase();
      const match =
        this.ultimasIa.find((item) => {
          const texto = (item.solicitacao || item.pergunta || item.descricao || "")
            .trim()
            .toLowerCase();
          return solicitacaoNorm && texto === solicitacaoNorm;
        }) || this.ultimasIa[0];

      if (!match) {
        return data;
      }

      return {
        ...data,
        idAgendaSql: data.idAgendaSql || match.idAgendaSql || match.id,
        ultimosRegistros: data.ultimosRegistros || match.ultimosRegistros || [],
      };
    },

    exibirSemResultadosConsultaIa(data) {
      this.pararDigitacaoBoasVindas();
      this.erroIaInlineVisivel = false;
      this.mensagemErroIaInline = null;
      const indice = Math.floor(
        Math.random() * MENSAGENS_SEM_RESULTADOS_SUCESSO.length
      );
      this.mensagemSemResultadosInline =
        MENSAGENS_SEM_RESULTADOS_SUCESSO[indice];
      this.semResultadosVisivel = true;
      this.dialogIaSemRegistros = false;
    },

    limparSemResultadosInline() {
      this.semResultadosVisivel = false;
      this.mensagemSemResultadosInline = null;
    },

    exibirErroConsultaIa(data) {
      const msg = this.obterMensagemErroIa(data);
      if (!msg) {
        return;
      }
      this.limparSemResultadosInline();
      this.pararDigitacaoBoasVindas();
      this.mensagemErroIaDialog = msg;
      this.mensagemErroIaInline = msg;
      this.erroIaInlineVisivel = true;
      this.dialogIaErro = false;
    },

    agendarOcultarErroInline(ms) {
      if (this.erroIaInlineTimeoutId) {
        clearTimeout(this.erroIaInlineTimeoutId);
      }
      this.erroIaInlineTimeoutId = setTimeout(() => {
        this.erroIaInlineVisivel = false;
        this.mensagemErroIaInline = null;
        this.erroIaInlineTimeoutId = null;
      }, ms);
    },

    limparErroInline() {
      if (this.erroIaInlineTimeoutId) {
        clearTimeout(this.erroIaInlineTimeoutId);
        this.erroIaInlineTimeoutId = null;
      }
      this.erroIaInlineVisivel = false;
      this.mensagemErroIaInline = null;
      this.limparSemResultadosInline();
      this.reiniciarBoasVindasSeAplicavel();
    },

    fecharDialogErroIa() {
      this.dialogIaErro = false;
    },

    fecharErroIaETentarNovamente() {
      this.fecharDialogErroIa();
      this.$nextTick(() => {
        const campo = this.$refs.campoSolicitacaoIa;
        if (campo && campo.focus) {
          campo.focus();
        }
      });
    },

    textoSolicitacaoHistorico(item) {
      return item.solicitacao || item.pergunta || item.descricao || "—";
    },

    dataHistoricoIa(item) {
      const raw =
        item.dataInclusao ||
        item.createdAt ||
        item.dataCriacao ||
        item.data ||
        null;
      if (!raw) {
        return "";
      }
      if (typeof raw === "string" && raw.includes("/")) {
        return raw;
      }
      const d = new Date(raw);
      if (Number.isNaN(d.getTime())) {
        return String(raw);
      }
      const dia = String(d.getDate()).padStart(2, "0");
      const mes = String(d.getMonth() + 1).padStart(2, "0");
      const ano = d.getFullYear();
      const hora = String(d.getHours()).padStart(2, "0");
      const min = String(d.getMinutes()).padStart(2, "0");
      return `${dia}/${mes}/${ano} ${hora}:${min}`;
    },

    async carregarUltimasIa() {
      this.carregandoUltimas = true;
      try {
        const response = await SqlAgent.ultimas(50);
        const lista = Array.isArray(response.data) ? response.data : [];
        this.ultimasIa = lista.map((item) => normalizarRespostaOrquestrar(item));
      } catch (err) {
        console.error("Erro ao carregar histórico:", err);
        this.ultimasIa = [];
      } finally {
        this.carregandoUltimas = false;
      }
    },

    visualizarUltimosRegistros() {
      if (!this.ultimaRespostaIa) {
        return;
      }
      this.ultimosRegistrosPreview = Array.isArray(
        this.ultimaRespostaIa.ultimosRegistros
      )
        ? this.ultimaRespostaIa.ultimosRegistros
        : [];
      this.dialogIaEscolha = false;
      this.dialogUltimosRegistros = true;
    },

    async baixarExcelAgenda(idAgendaSql) {
      await this.executarNovoExportarExcel(idAgendaSql, { fecharDialogEscolha: true });
    },

    async novoProcessamentoAgenda(idAgendaSql) {
      await this.executarNovoExportarExcel(idAgendaSql, { fecharDialogEscolha: false });
    },

    async executarNovoExportarExcel(idAgendaSql, { fecharDialogEscolha = false } = {}) {
      if (!idAgendaSql || this.baixandoExcelId) {
        return;
      }
      this.baixandoExcelId = idAgendaSql;
      this.$emit("baixando-excel", true);
      try {
        const response = await SqlAgent.novoExportarExcel(idAgendaSql);
        const fileName = `consulta_ia_${idAgendaSql}_${Date.now()}.xlsx`;
        const fileURL = URL.createObjectURL(new Blob([response.data]));
        const fileLink = document.createElement("a");
        fileLink.href = fileURL;
        fileLink.setAttribute("download", fileName);
        document.body.appendChild(fileLink);
        fileLink.click();
        document.body.removeChild(fileLink);
        URL.revokeObjectURL(fileURL);
        if (fecharDialogEscolha) {
          this.dialogIaEscolha = false;
        }
      } catch (err) {
        const msg =
          err.response?.data?.mensagem ||
          err.response?.data?.message ||
          "Erro ao executar o novo processamento.";
        this.exibirErroConsultaIa({ mensagemErro: msg });
      } finally {
        this.baixandoExcelId = null;
        this.$emit("baixando-excel", false);
      }
    },

    async gerarConsulta() {
      const solicitacao = (this.solicitacaoIa || "").trim();
      if (!solicitacao) {
        return;
      }

      this.gerandoSqlIa = true;
      this.limparErroInline();
      this.mensagemErroIaDialog = null;
      this.ultimaRespostaIa = null;
      this.dialogIaErro = false;
      this.dialogIaSemRegistros = false;
      this.dialogIaEscolha = false;

      try {
        const response = await SqlAgent.gerar(solicitacao);
        let data = normalizarRespostaOrquestrar(response.data || {});

        await this.carregarUltimasIa();
        data = this.enriquecerRespostaComHistorico(data, solicitacao);
        this.ultimaRespostaIa = data;

        if (!data.sucesso) {
          this.exibirErroConsultaIa(data);
          return;
        }

        const qtd = Number(data.quantidadeRegistros) || 0;
        if (qtd > 0) {
          this.limparSemResultadosInline();
          this.dialogIaEscolha = true;
        } else {
          this.exibirSemResultadosConsultaIa(data);
        }

        this.solicitacaoIa = "";
      } catch (err) {
        this.exibirErroConsultaIa(this.extrairPayloadErro(err));
        await this.carregarUltimasIa();
      } finally {
        this.gerandoSqlIa = false;
      }
    },
  },
};
</script>

<style scoped>
.assistente-consulta-wrap {
  max-width: 1100px;
  margin: 0 auto;
  padding-top: 56px !important;
}

.historico-ia-card {
  background-color: #fafafa;
}

.historico-ia-solicitacao {
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.ia-historico-erro {
  color: #5c6b7a;
  line-height: 1.4;
}

.ia-chat-panel {
  background: linear-gradient(180deg, #f8fafc 0%, #eef2f7 100%);
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 4px 24px rgba(71, 130, 180, 0.08);
}

.ia-chat-header {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}

.ia-chat-header-title {
  font-size: 1.05rem;
  font-weight: 600;
  color: rgb(71 130 180);
}

.ia-chat-apresentacao {
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 16px;
}

.ia-chat-mascote-img {
  height: 140px;
  width: auto;
  max-width: 120px;
  object-fit: contain;
  display: block;
  transition: opacity 0.25s ease;
}

.ia-chat-fala {
  flex: 1;
  min-width: 0;
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  padding: 14px 16px;
  box-shadow: 0 2px 8px rgba(71, 130, 180, 0.06);
}

.ia-chat-fala-texto {
  font-size: 0.9rem;
  line-height: 1.55;
  color: #334155;
  white-space: pre-wrap;
}

.ia-chat-fala-exemplo {
  font-style: italic;
  color: #475569;
  padding-left: 8px;
  border-left: 3px solid rgb(71, 130, 180);
}

.ia-cursor-digitacao::after {
  content: "|";
  color: rgb(71, 130, 180);
  font-weight: 600;
  margin-left: 1px;
  animation: ia-cursor-piscar 0.75s step-end infinite;
}

@keyframes ia-cursor-piscar {
  50% {
    opacity: 0;
  }
}

.ia-chat-fala-processando {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 80px;
}

.ia-chat-fala-erro {
  border-color: #fde68a;
  background: #fffbeb;
}

.ia-chat-fala-erro-hint {
  font-size: 0.8rem;
  color: #64748b;
}

.ia-chat-fala-sem-resultados {
  border-color: #bfdbfe;
  background: #f0f9ff;
}

@media (max-width: 600px) {
  .ia-chat-apresentacao {
    flex-direction: column;
    align-items: center;
  }

  .ia-chat-mascote-img {
    height: 100px;
    max-width: 100px;
  }

  .ia-chat-fala {
    width: 100%;
  }
}

.ia-chat-bubble {
  max-width: 92%;
  padding: 12px 16px;
  border-radius: 16px;
  margin-bottom: 10px;
  font-size: 0.9rem;
  line-height: 1.5;
}

.ia-chat-bubble-assistant {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-bottom-left-radius: 4px;
  color: #334155;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}

.ia-chat-bubble-hint {
  color: #64748b;
}

.ia-chat-bubble-text {
  font-family: inherit;
  white-space: pre-wrap;
  word-break: break-word;
  font-size: 0.9rem;
}

.ia-chat-typing {
  display: flex;
  align-items: center;
}

.ia-typing-dot {
  width: 8px;
  height: 8px;
  margin: 0 3px;
  background: rgb(71 130 180);
  border-radius: 50%;
  animation: ia-typing 1.2s infinite ease-in-out;
}

.ia-typing-dot:nth-child(2) {
  animation-delay: 0.15s;
}

.ia-typing-dot:nth-child(3) {
  animation-delay: 0.3s;
}

@keyframes ia-typing {
  0%,
  80%,
  100% {
    transform: scale(0.6);
    opacity: 0.4;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}

.ia-chat-input-wrap {
  display: flex;
  align-items: flex-end;
  gap: 10px;
  background: #fff;
  border: 1px solid #cbd5e1;
  border-radius: 24px;
  padding: 8px 8px 8px 16px;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.06);
  transition: border-color 0.2s, box-shadow 0.2s;
}

.ia-chat-input-wrap:focus-within {
  border-color: rgb(71 130 180);
  box-shadow: 0 0 0 3px rgba(71, 130, 180, 0.15);
}

.ia-chat-input {
  flex: 1;
}

.ia-chat-input >>> .v-input__slot {
  background: transparent !important;
  box-shadow: none !important;
  min-height: 88px !important;
  padding: 0 !important;
}

.ia-chat-input >>> textarea {
  font-size: 0.95rem;
  line-height: 1.45;
  min-height: 72px !important;
  max-height: 220px;
  margin-top: 0 !important;
}

.ia-chat-bubble-erro {
  position: relative;
  border-color: #fecaca;
  background: #fff5f5;
  padding-right: 28px;
}

.ia-chat-erro-fechar {
  position: absolute !important;
  top: 4px;
  right: 4px;
}

.ia-erro-fade-enter-active,
.ia-erro-fade-leave-active {
  transition: opacity 0.25s ease;
}

.ia-erro-fade-enter,
.ia-erro-fade-leave-to {
  opacity: 0;
}

.ia-chat-send-btn {
  flex-shrink: 0;
  box-shadow: 0 2px 8px rgba(71, 130, 180, 0.35) !important;
}

.ia-chat-footer-hint {
  text-align: center;
  font-size: 0.7rem;
  color: #94a3b8;
  margin-top: 10px;
}

.ia-erro-dialog {
  border-radius: 16px;
}

.ia-erro-emoji {
  font-size: 3rem;
  line-height: 1;
}

.ia-erro-amigavel {
  font-family: inherit;
  white-space: pre-wrap;
  text-align: center;
  font-size: 0.95rem;
  line-height: 1.55;
  color: #475569;
  background: transparent;
  border: none;
  margin: 0;
}

.link-novo-processamento {
  font-size: 0.75rem;
  color: rgb(71, 130, 180);
  cursor: pointer;
  text-decoration: underline;
  text-underline-offset: 2px;
  vertical-align: middle;
}

.link-novo-processamento:hover {
  color: rgb(55, 105, 155);
}

.link-novo-processamento--disabled {
  pointer-events: none;
  opacity: 0.6;
  cursor: default;
}

.assistente-escolha-list {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.assistente-escolha-item:not(.v-list-item--disabled) {
  cursor: pointer;
}

.assistente-escolha-item:not(.v-list-item--disabled):hover {
  background: #eef4fa;
}

.assistente-escolha-emoji {
  font-size: 1.25rem;
  line-height: 1;
}
</style>
